import { render, staticRenderFns } from "./QuickAlert.vue?vue&type=template&id=37f626d5&scoped=true&"
import script from "./QuickAlert.vue?vue&type=script&lang=js&"
export * from "./QuickAlert.vue?vue&type=script&lang=js&"
import style0 from "./QuickAlert.vue?vue&type=style&index=0&id=37f626d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f626d5",
  null
  
)

export default component.exports